import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getCasinoGamePartners = (data: PropertyType): Promise<PropertyType> =>
	api.post(`games/all-partners${data?.query}`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
